import { useAuth } from "@/contexts/AuthContext";
import { useStaffIndustryView } from "@/hooks/useStaffIndustryView";
import { Navigate } from "@/lib/router-compat";
import { INDUSTRY_BUILDER_ROUTE } from "./IndustryBuilderGuard";
import Index from "@/pages/Index";
import Industries from "@/pages/Industries";
import ProposalBuilder from "@/pages/ProposalBuilder";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

export const PageLoader = () => <div className="min-h-screen bg-background flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
export const HomePage = () => {
  const { user, isLoading } = useAuth();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (isLoading && mounted) return <PageLoader />;
  return user ? <Index /> : <Industries />;
};
export const SmartBuilderRoute = () => {
  const { effectiveIndustry } = useStaffIndustryView();
  const route = INDUSTRY_BUILDER_ROUTE[effectiveIndustry];
  if (route && route !== "/builder") return <Navigate to={route} replace />;
  return <ProposalBuilder />;
};